// extracted by mini-css-extract-plugin
export default {"hr-line":"Footer_hr-line__7kQlU"};